import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

function loadLocaleMessages() {
  const locales = require.context(
    './locales',
    true,
    /[A-Za-z0-9-_,\s]+\.json$/i
  );
  const messages = {};
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key);
    }
  });
  return messages;
}

export default new VueI18n({
  // TODO: Change locales logic if not only hebrew is supported
  //locale: 'he',
  locale:
    localStorage != undefined && localStorage.getItem('selectedLang')
      ? localStorage.getItem('selectedLang')
      : 'he',
  // locale: process.env.VUE_APP_I18N_LOCALE || 'he',
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'he',
  // fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
  messages: loadLocaleMessages()
});
